define(["./mapsModule"], function (mapsModule) {
    "use strict";

    return mapsModule.directive("nlgRouteOverlayPath", [function () {
        return {
            restrict: "E",
            scope: {
                path: "=?",
                paths: "=?",
                toggle: "=?",
                distinctPaths: "=?"
            },
            require: "mapControl",
            link: function (scope, attrs, element, mapControlController) {
                scope.mapControlController = mapControlController;
            },
            controller: ["$scope", "uiGmapGoogleMapApi", "mapsLatLngApi", "$attrs", function ($scope, uiGmapGoogleMapApi, mapsLatLngApiPromise, $attrs) {
                var mapApi, mapsLatLngApi, map, polylines = [];
                uiGmapGoogleMapApi.then(function (_mapApi) {
                    return mapApi = _mapApi;
                }).then(function () {
                    return $scope.mapControlController.getMapControl();
                }).then(function (mapControl) {
                    map = mapControl.getGMap();
                    return mapsLatLngApiPromise;
                }).then(function (_mapsLatLngApi) {
                    mapsLatLngApi = _mapsLatLngApi;
                }).then(function () {
                    $scope.$watchCollection("path", function (path) {
                        drawPaths([path]);
                    });
                    $scope.$watchCollection("paths", drawPaths);
                    $scope.$watchCollection("distinctPaths", drawDistinctPaths);
                    if($attrs.toggle){
                        $scope.$watch("toggle", togglePath);
                    }
                });

                function clearPaths() {
                    polylines.forEach(function (polyline) {
                        polyline.setMap(null);
                    });
                    polylines = [];
                }

                function drawPaths(paths) {
                    clearPaths();
                    (paths || []).forEach(function (value) {
                        if (!value || !value.path) {
                            return;
                        }
                        var pathPolyline = new mapApi.Polyline({
                            path: value.path.map(mapsLatLngApi.toLatLng),
                            geodesic: true,
                            strokeColor: value.color || "#000000",
                            strokeOpacity: 1.0,
                            strokeWeight: 2
                        });
                        pathPolyline.setMap(map);
                        polylines.push(pathPolyline);
                    });
                }

                function drawDistinctPaths(distinctPaths) {
                    if (!distinctPaths){
                        return;
                    }
                    clearPaths();
                    (distinctPaths || []).forEach(function (paths) {
                        paths.forEach(function (path) {
                            if (!path || !path.path) {
                                return;
                            }
                            var pathPolyline = new mapApi.Polyline({
                                path: path.path.map(mapsLatLngApi.toLatLng),
                                geodesic: true,
                                strokeColor: path.color || "#000000",
                                strokeOpacity: 1.0,
                                strokeWeight: 2
                            });
                            pathPolyline.setMap(map);
                            polylines.push(pathPolyline);
                        });
                    });
                }

                function togglePath(toggle) {
                    if (toggle) {
                        if ($scope.paths && $scope.paths.length > 0) {
                            drawPaths($scope.paths);
                        } else {
                            if ($scope.distinctPaths){
                                return drawDistinctPaths($scope.distinctPaths);
                            }
                            drawPaths([$scope.path]);
                        }
                    } else {
                        clearPaths();
                    }
                }
            }]
        };
    }]);
});